import { useContext } from 'react'
import { BrandColors } from '../BrandColors.type'
import MozgotekaContext from '../MozgotekaContext'

const useMozgotekaContext = (
  component: string,
  force: boolean = true
): BrandColors => {
  const context = useContext(MozgotekaContext)
  if (force && !context) {
    const err = new Error(`<${component} /> is missing MozgotekaContext`)
    Error.captureStackTrace?.(err, useMozgotekaContext)
    // throw err
    console.warn(err)
  }
  return context as BrandColors
}

export default useMozgotekaContext
